import { useCallback, useRef, useState } from 'react';
import { api } from '../api';
import type { PublicDemoFormStatus } from '../components/DemoFormFeedback';

export type PublicFormStatus = PublicDemoFormStatus;

/**
 * POST JSON to a public API path (under /api). Prevents overlapping submits.
 */
export function usePublicFormSubmit() {
  const inFlightRef = useRef(false);
  const [status, setStatus] = useState<PublicFormStatus>('idle');

  const runSubmit = useCallback(async (path: string, body: Record<string, string>) => {
    if (inFlightRef.current) return false;
    inFlightRef.current = true;
    setStatus('loading');
    try {
      await api.post(path, body);
      setStatus('success');
      return true;
    } catch {
      setStatus('error');
      return false;
    } finally {
      inFlightRef.current = false;
    }
  }, []);

  return {
    status,
    runSubmit,
    isSubmitting: status === 'loading',
  };
}
